/**
 * `#rrggbb` to an `r, g, b` triple, so one colour can drive both a solid border
 * and its 10% wash. pymble-swipe's `hexToRgba` in utils/constants.ts does the
 * same; it returns undefined for anything that is not 6 hex digits, so this
 * falls back to the brand navy rather than emitting `rgb(undefined)`.
 *
 * Shared rather than private to the calendar page: the List and Cards views
 * tint their accent bars from the same category colour the calendar tints its
 * labels with, and two copies of this would drift.
 */
export function hexToRgbTriple(hex: string | undefined): string {
	const clean = (hex ?? "").replace(/^#/, "");
	if (!/^[0-9a-f]{6}$/i.test(clean)) return "0, 47, 103";
	return [
		parseInt(clean.slice(0, 2), 16),
		parseInt(clean.slice(2, 4), 16),
		parseInt(clean.slice(4, 6), 16),
	].join(", ");
}
